module.exports = __webpack_public_path__ + "img/c_sv2.4301c40.png";